import React from 'react';

import { width } from './dom';

const getDragX = (e) => e?.touches?.[0]?.pageX ?? e?.pageX;

const getIndex = (infinite, childrenLength, index, widthSubColumn = false, totalSubColumns = false, nextIndex = false) => {
	if (nextIndex === false) index += 1;
	else index = nextIndex;

	let totalLength = infinite ? childrenLength + infinite : childrenLength;
	if (widthSubColumn) {
		totalLength *= widthSubColumn;
		if (totalSubColumns) totalLength = totalSubColumns + (infinite > 0 ? (totalSubColumns % widthSubColumn) + (infinite * widthSubColumn) : 0);
	}

	let totalInfinite = infinite;
	if (widthSubColumn) {
		totalInfinite *= widthSubColumn;
		if (totalSubColumns) totalInfinite = infinite > 0 ? (totalSubColumns % widthSubColumn) + (infinite * widthSubColumn) : 0;
	}

	if (index >= totalLength) {
		return 0 + totalInfinite;
	}
	if (index < totalInfinite) {
		return totalLength - 1;
	}
	return index;
};

const getMediaChild = (childrenCopy) => (
	React.Children.map(childrenCopy, (child) => {
		if (!React.isValidElement(child)) return child;
		if ((child.type !== 'img' || child.type !== 'video') && child.props.children) return getMediaChild(child.props.children);
		return child;
	})
);

const getDynamicSlideWidths = (slider, sliderInner, infinite, slideGap, index) => {
	const slideWidths = [...(sliderInner?.children || [])].map((child) => width(child));

	if (slideWidths.includes(false)) {
		return {
			width: 'auto',
			transform: 'translateX(0)',
		};
	}

	const totalWidth = slideWidths.reduce((acc, w) => acc + w, 0);
	const currentPosition = slideWidths.slice(0, index).reduce((acc, w) => acc + w + slideGap, 0) - slideGap;

	// Center slides in window
	const windowWidth = slider?.offsetWidth || 375;

	return {
		width: `${totalWidth + ((slideWidths.length - 1) * slideGap)}px`,
		transform: `translateX(${((currentPosition + (slideWidths[index] / 2) + slideGap) - (windowWidth / 2)) * -1}px)`,
	};
};

export { getDragX, getIndex, getMediaChild, getDynamicSlideWidths };
